const Defaults = require('../util/defaults');
var EventEmitter = require('event-emitter');
var emitter = EventEmitter({});

const Modules = {
    AgeAdvisor: require('./../modules/age_advisor/age_advisor'),
    PauseScreen: require('./../modules/pause_screen/pause_screen'),
    RatingScreen: require('./../modules/rating_screen/rating_screen'),
    Controls: require('./../modules/controls/controls'),
    Subtitles: require('./../modules/subtitles_audio_track/subtitles_audio_track'),
    VideoQuality: require('./../modules/video_quality/video_quality'),
    Filmstrip: require('./../modules/filmstrip/filmstrip'),
    PlayerTitle: require('./../modules/player_title/player_title'),
    DeviceManager: require('./../modules/device_manager/device_manager').default,
    BackButton: require('./../modules/backbutton/back_button').default,
    Youbora: require('./../modules/report/youbora'),
    MediaList: require('../modules/media_list/media_list'),
    RecommendationEngine: require('../modules/recommendation_engine/recommendation_engine'),
    IdleControlsTracker: require('../modules/idle_controls_tracker/idle_controls_tracker').default,
    Preferences: require('../util/preferences_utils.js').default
};

module.exports = function(config, adapter, options) {
    var pauseScreen = new Modules.PauseScreen(emitter);
    var recommendationEngine = new Modules.RecommendationEngine({
        contentId: config.content.id,
        userId: config.user.globalUserId,
        moduleId: config.recEngine.moduleId,
        adapter: adapter,
        sessionToken: config.user.sessionToken,
        packageName: config.user.packageName,
        isLive: config.user.isLive,
        sessionId: config.user.sessionId,
        enableConcurrency: config.user.enableConcurrency
    });

    const Preferences = new Modules.Preferences({
        userId: config.user.globalUserId,
        sessionToken: config.user.sessionToken
    });

    Preferences.registerEvents(emitter);

    emitter.on('menu-shown', function(menu) {
        switch (menu) {
            case 'pause-screen':
                Modules.Subtitles.hide();
                Modules.VideoQuality.hide();
                Modules.Controls.hide();
                pauseScreen.hideResume();
                break;
            case 'subtitles-audio-selector':
                Modules.VideoQuality.hide();
                Modules.Controls.lockVisible();
                Modules.IdleControlsTracker.register(() => Modules.Subtitles.hide());
                break;
            case 'video-quality-selector':
                Modules.Subtitles.hide();
                Modules.Controls.lockVisible();
                Modules.IdleControlsTracker.register(() => Modules.VideoQuality.hide());
                break;
            case 'resume-screen':
                Modules.Subtitles.hide();
                Modules.VideoQuality.hide();
                Modules.Controls.hide();
                break;
            case 'opt-out-selector':
                Modules.Subtitles.hide();
                Modules.VideoQuality.hide();
                Modules.Controls.lockVisible();
                break;
        }

    });

    emitter.on('menu-hidden', function() {
        Modules.Controls.unlockVisible();
    });

    emitter.on('player-exit', function() {
        recommendationEngine.sendEvent('stop');
    });

    return {
        onInit: function() {
            Modules.Controls.init();
            Modules.BackButton.init(adapter, emitter);
            Modules.MediaList.initialize({
                videoType: 'movie',
                contentId: config.content.id,
                userId: config.user.globalUserId,
                adapter: adapter,
                sessionToken: config.user.sessionToken,
                mediaId: config.content.id,
                packageName: config.user.packageName,
                isLive: config.user.isLive,
                sessionId: config.user.sessionId
            });

            // FIXME: Enable when the integration is done properly.
            // Modules.DeviceManager.init(config, emitter);
        },
        onPlay() {

            const muted = Defaults.getValue('muted');
            if (muted) {
                adapter.mute();
            } else {
                const volumeLevel = Defaults.getValue('volume');
                if (volumeLevel <= 0) {
                    adapter.mute();
                } else {
                    const volumeLevel = Defaults.getValue('volume');
                    adapter.setVolume(volumeLevel);
                }
            }

            pauseScreen.hide();
            Modules.Subtitles.initLayout(adapter, emitter);
            Modules.VideoQuality.initLayout(adapter, emitter);
            Modules.MediaList.startUpdating();
            Modules.Controls.initializeTooltipWrapper();
        },

        onPause: function() {
            let menushown = false;
            let menus = document.querySelectorAll('.bitdash-settings--custom, .bitdash-settings--videoquality, .player-modal--resume');

            for (let i = 0; i < menus.length; i++) {
                let isShown = menus[i].classList.contains('is-shown');

                if (isShown) {
                    menushown = true;
                    break;
                }
            }

            if (!menushown) {
                pauseScreen.show({
                    title: config.content.title,
                    description: config.content.shortDescription
                }, adapter.play);
            }
            Modules.MediaList.stopUpdating();
        },
        onAudioChange: function(event) {
            return this.setAudio(event.targetAudio);
        },
        onReady: function() {
            adapter.startBuffering(adapter);
            setTimeout(() => adapter.seek(config.content.startAt), 100);
            Modules.PlayerTitle.showTitle(config.content.title);
            new Modules.Filmstrip(config.content.filmstripUri);
            Modules.AgeAdvisor.showAgeScreen({
                ageRestriction: config.content.ageRestriction
            }, adapter.pause, adapter.play);

            document.querySelector('.bitdash-ctrl-w').addEventListener('click', event => {
                const visibleElem = document.querySelector('[data-is-visible="1"]');
                let visibleElemDimensions = {};

                if (visibleElem) {
                    visibleElemDimensions = {
                        left: visibleElem.offsetLeft && visibleElem.offsetLeft,
                        bottom: visibleElem.scrollHeight || visibleElem.scrollHeight
                    };
                }

                if (!(event.screenX - visibleElemDimensions.left >= 0 && event.screenY - visibleElemDimensions.bottom < 0)) {

                    Modules.Subtitles.hide();
                    Modules.VideoQuality.hide();
                    Modules.Controls.show();
                }

                return true;
            });

            Modules.IdleControlsTracker.initListenerEvents();
            return true;
        },
        onPlaybackFinished: function() {
            Modules.MediaList.stopUpdating();
            Modules.MediaList.moveToWatchedList();

            Modules.RatingScreen.show(config.user.sessionToken, config.user.globalUserId, config.content.id, {title: config.content.title});
            adapter.exitFullscreen();
        },

        onDestroy: function() {
            pauseScreen.hide();
            recommendationEngine.sendEvent('stop');
        },

        onTimeChange: function(event) {
            recommendationEngine.monitorPlayback(event);
        },

        onVolumeChange(volumeObj) {
            if(volumeObj.targetVolume < 1) {
                adapter.mute();
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/event_handlers/movies.js